/* eslint-disable no-unused-vars */
/* global PLATFORM, G */
import settings from '@tenant/settings'
import find from 'lib/sequence/component/children/find'
import { asyncPipeSpread, bulk } from 'lib/util'
import initAddress from 'app/_shared/action/address/init'
import displayState from 'app/_shared/events/address/displayState'
import displayHouseNumber from 'app/_shared/events/address/displayHouseNumber'
import { hide } from 'lib/sequence/component/state/hidden'
import { get } from 'lib/sequence/component/state/value'
import { stretch } from 'lib/sequence/component/state/width'

const bulkHide = bulk(hide)

const initOrganisationAddress = initAddress(
  { component: 'country' },
  { attribute: 'organisation' },
)

/**
 * Displays the organisation's `number`
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const displayCustomerNumber = module => async (children, ...args) => {
  const { number } = children

  const shouldHide = !get(number) || settings.suppressOrganisationCustomerNumber

  if (PLATFORM === 'mobile') {
    const { numberDivider } = children

    shouldHide && bulkHide(number, numberDivider)
  }

  if (PLATFORM === 'web') {
    const { name } = children

    shouldHide
      && hide(number)
      && stretch(name)
  }

  return [children, ...args]
}

/**
 * Hides the supported by field if the `suppressSupportedBy` setting is enabled.
 *
 * @param {Object} module the ticket module composition object
 * @return {function(*, ...[*]): Promise<*[]>}
 */
const displaySupportedBy = module => async (components, ...args) => {
  const { supportedBy } = components

  settings.suppressSupportedBy && hide(supportedBy)

  return [components, ...args]
}

const finish = async (components, ...args) => args

/**
 * Organisation editing and creation.
 *
 * Toggles the visibility and mapping of fields depending on whether the organisation should just be
 * saved for a ticket or as an individual entity in the database and whether there is already an
 * entity selected.
 *
 * @param {Object} module the ticket module composition object
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  displayCustomerNumber(module),
  displaySupportedBy(module),
  initOrganisationAddress(
    displayState('state', 'country'),
    displayHouseNumber('number', 'street'),
  )(module),
  finish,
)(find(component), ...args)
